module.exports = __webpack_public_path__ + "img/characteristic3.c5b58ec9.png";